/**
 * Shared utility functions for Reflux replacement.
 * These utilities are used across multiple modules to avoid code duplication.
 *
 * @module reflux/utils
 */

/**
 * Capitalizes the first letter of a string.
 * Used for generating callback method names from action names.
 *
 * @param {string} str - String to capitalize
 * @returns {string} Capitalized string
 *
 * @example
 * capitalize('login') // 'Login'
 * capitalize('fetchData') // 'FetchData'
 */
export const capitalize = (str) =>
  typeof str === 'string' && str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

/**
 * Generates callback method name from action/listenable name.
 * Follows Reflux naming convention: action name → onActionName.
 *
 * @param {string} name - Action or listenable name
 * @param {string} [prefix='on'] - Prefix for callback name
 * @returns {string} Callback method name
 *
 * @example
 * callbackName('login') // 'onLogin'
 * callbackName('fetchData') // 'onFetchData'
 * callbackName('completed', 'handle') // 'handleCompleted'
 */
export const callbackName = (name, prefix = 'on') => {
  return prefix + capitalize(name);
};
